import { ForgotPasswordView } from './forgot-password';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { GatewayContent } from './general';
import { InvitationView } from './invitation';
import { OIDCIntegration } from './integrations';
import { ResetPasswordView } from './reset-password';
import { SignupView } from './sign-up';
import { useSonarSelector } from '@hooks';
import { createIsReceivedSelector, createSonarSelector } from '@lib/selectors';
import { LoginRedirectRoute, LoginView } from './login';
import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

const isLoggingOutSelector = createSonarSelector((state) => state.application.reset.isLoggingOut);
const isLoggingInSelector = createIsReceivedSelector((state) => state.security.authentication.login.post);

export const UnauthorizedView: React.FC = () => {
	const isLoggingIn = useSonarSelector(isLoggingInSelector);
	const isLoggingOut = useSonarSelector(isLoggingOutSelector);

	useEffect(() => {
		if (isLoggingOut) {
			window.location.reload();
		}
	}, [ isLoggingOut ]);

	if (isLoggingIn || isLoggingOut) {
		return <GatewayContent />;
	}

	return (
		<GatewayContent>
			<Routes>
				<Route
					element={ <LoginView /> }
					path='/' />
				<Route
					element={ <InvitationView /> }
					path={ FULL_ROUTES.INVITATION } />
				<Route
					element={ <ForgotPasswordView /> }
					path={ FULL_ROUTES.FORGOT_PASSWORD } />
				<Route
					element={ <LoginView /> }
					path={ FULL_ROUTES.LOGIN } />
				<Route
					element={ <ResetPasswordView /> }
					path={ FULL_ROUTES.RESET_PASSWORD } />
				<Route
					element={ <SignupView /> }
					path={ FULL_ROUTES.SIGN_UP } />
				<Route
					element={ <OIDCIntegration /> }
					path={ FULL_ROUTES.INTEGRATIONS_OIDC } />
				<Route
					element={ <LoginRedirectRoute /> }
					path='*' />
			</Routes>
		</GatewayContent>
	);
};
